<div class="receivables-balance-note-list-container">
  <table mat-table [dataSource]="receivablesBalanceNoteDataSource">

    <!-- Position Column -->


    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data dodania</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef> Treść notatki</th>
      <td mat-cell *matCellDef="let element">
        {{element.note}}
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdBy?.firstName + ' ' + element.createdBy?.lastName}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
</div>
